export default "__VITE_ASSET__BBBXiYGQ__"